import OwnerHeader from './OwnerHeader'
import OwnerFooter from './OwnerFooter'
import PwaOfflineNotice from '../../pwa/PwaOfflineNotice'
import PwaUpdateToast from '../../pwa/PwaUpdateToast'

/**
 * Page frame for the owner page: the M1NT header (fixed), the page content and
 * the M1NT footer, on the shared ground colour. The scope class `m1nt-owner`
 * carries the design tokens, so the rest of the app is never affected.
 */
export default function OwnerShell({ children }) {
  return (
    <div className="m1nt-owner flex overflow-x-clip min-h-screen min-h-[100dvh] flex-col bg-m1-ground font-m1-ui text-m1-ink">
      <OwnerHeader />
      <main className="flex-1">{children}</main>
      <OwnerFooter />
      <PwaOfflineNotice />
      <PwaUpdateToast />
    </div>
  )
}
